const ACTIONS = {
  SIGNAL_R__HANDLE_CONNECT_EVENT: 'SIGNAL_R__HANDLE_CONNECT_EVENT',
  SIGNAL_R__HANDLE_EXERCISE_CHANGE: 'SIGNAL_R__HANDLE_EXERCISE_CHANGE',
  SIGNAL_R__HANDLE_DOCUMENT_CHANGE: 'SIGNAL_R__HANDLE_DOCUMENT_CHANGE',
  SIGNAL_R__HANDLE_CHANGE_EVENT: 'SIGNAL_R__HANDLE_CHANGE_EVENT',
  SIGNAL_R__HANDLE_CLIENT_PARTICIPANT_NETWORK_EVENT: 'SIGNAL_R__HANDLE_CLIENT_PARTICIPANT_NETWORK_EVENT',
  SIGNAL_R__HANDLE_CLIENT_OBSERVER_NETWORK_EVENT: 'SIGNAL_R__HANDLE_CLIENT_OBSERVER_NETWORK_EVENT',
  SIGNAL_R__SET_HUB_TOKEN: 'SIGNAL_R__SET_HUB_TOKEN',
  SIGNAL_R__SET_RUN_STATE: 'SIGNAL_R__SET_RUN_STATE',
  SIGNAL_R__HANDLE_OBSERVERTRAINING: 'SIGNAL_R__HANDLE_OBSERVERTRAINING'
}

export default ACTIONS;
